import { EonUiTooltip } from "@eon-ui/eon-ui-components-react";
import { Icon } from "@me8eon/icons";

const OnboardingFormLabel = ({
    label,
    tooltip,
}: {
    label: string;
    tooltip: string;
}) => {
    return (
        <>
            <div className="onboarding-portal--form--label">
                <span>{label}</span>
                <div className="onboarding-portal--form--label-icon">
                    <Icon name="info_small" style={{ cursor: "pointer" }} />
                    <EonUiTooltip
                        visibility="onHover"
                        placement="top"
                        size="small"
                        style={{
                            fontSize: 12,
                            lineHeight: "16px",
                            textAlign: "center",
                            maxWidth: 250,
                            zIndex: 9999,
                        }}
                    >
                        {tooltip}
                    </EonUiTooltip>
                </div>
            </div>
        </>
    );
};

export default OnboardingFormLabel;
